<div class="fixed-min-header-height">
  <div class="full-width-control d-block d-lg-none" *ngIf="componentLoaded">
    <!-- Sorting and filter for mobile and ipad -->
    <div class="quick-add-accordion common-accordion">
      <accordion [isAnimated]="true" [closeOthers]="true">

        <div class="accordion-header-pink">
          <accordion-group heading="Order Details">
            <div class="quick-add-box order-details">
              <h3 class="d-none d-lg-block">Order Details</h3>
              <div class="product-detail">
                <div class="status {{orderStatueClasses[orderDetails['status']]}}">
                  <p>{{orderDetails['status']}}</p>
                </div>
                <ul>
                  <li>
                    <p>Order Date</p>
                    <span>{{orderDetails['created_at'] | dateTimeFormatFilter: "d MMM, y"}}</span>
                  </li>
                  <li>
                    <p>Order ID</p>
                    <span>{{orderDetails['increment_id']}}</span>
                  </li>
                  <li>
                    <p>Items</p>
                    <span>
                      {{orderDetails['total_cases_delivered']}}/{{orderDetails['total_qty']}} Delivered
                    </span>
                  </li>

                  <li>
                    <p>Cases</p>
                    <span>{{orderDetails['total_items_delivered']}}/{{orderDetails['total_items']}} Delivered</span>
                  </li>

                  <li>
                    <p>Store Name</p>
                    <span>{{orderDetails['store_name']}}</span>
                  </li>

                </ul>
              </div>
              <div class="product-detail cart-product-detail">

                <div class="promotion-listing discount first" *ngIf="global_data['price_visibility'] == 1">
                  <h5>
                    Net Amount:
                  </h5>
                  <span *ngIf="orderDetails['cart_total'] != undefined">£{{orderDetails['cart_total']?.subtotal}}</span>
                </div>
                <div class="promotion-listing"
                  *ngIf='orderDetails["cart_total"]?.promotions != undefined && orderDetails["cart_total"]?.promotions?.length != 0 && global_data["price_visibility"] == 1'>
                  <h5>
                    Promotion:
                  </h5>
                  <ul>
                    <li *ngFor="let pro of orderDetails['cart_total']?.promotions">
                      <p>{{pro.name}}</p><span class="red" *ngIf=" global_data?.price_visibility == 1">-
                        £{{pro.discount}}</span>
                    </li>
                  </ul>
                </div>
                <div class="promotion-listing discount"
                  *ngIf=" orderDetails.cart_total != undefined &&  global_data?.price_visibility == 1 && (orderDetails['cart_total']?.store_discount != '' && orderDetails['cart_total']?.store_discount > 0)">

                  <h5>
                    Discount Applied:
                    <!-- Store Discount -->
                  </h5>
                  <span class="red">- £{{orderDetails['cart_total'].store_discount}}</span>
                </div>
                <div class="promotion-listing discount" *ngIf=" global_data?.price_visibility == 1 && (orderDetails['cart_total'] != undefined) &&  convertToInt(orderDetails['cart_total']?.vat) > 0">
                  <h5>
                    VAT:
                  </h5>
                  <span *ngIf="orderDetails['cart_total'] != undefined ">£{{orderDetails['cart_total']?.vat}}</span>
                </div>
                <div class="promotion-listing discount total" *ngIf=" global_data?.price_visibility == 1">
                  <h5>
                    Total Amount:
                  </h5>
                  <span
                    *ngIf="orderDetails['cart_total'] != undefined">£{{orderDetails['cart_total']?.grand_total}}</span>
                </div>

                <!-- <button class="view-btn btn primary-btn w-100 rounded-pill" > View Invoice</button>  -->
              </div>
            </div>
            <div class="invoice-discount"
              *ngIf="orderDetails['discount_description'] != null && global_data['price_visibility'] != 1">
              <img src="../../assets/images/percent-icon.svg" alt="percent-icon"> Invoice discount will be applied to
              these values.
            </div>
          </accordion-group>
        </div>
      </accordion>
    </div>
  </div>
  <div class="container-fluid product-lisitng-wrapper cart-lisitng-wrapper order-detail-wrapper"
    *ngIf="componentLoaded">
    <div class="row">
      <div class="col-12 fixed-width-right-column">
        <ul class="breadcrumbs d-flex">
          <li><a routerLink="/" title="Home">Home</a></li>
          <li><span><img src="../../assets/images/seperator-arrow.svg" alt="seperator-arrow"></span></li>
          <li><a [routerLink]="['/order']" title="My Orders">My Orders</a></li>
          <li><span><img src="../../assets/images/seperator-arrow.svg" alt="seperator-arrow"></span></li>
          <li> Order Details </li>
        </ul>
        <div class=" accordion-open-default-ipad">
          <div class="table-listing white-bg">
            <div class="table-header">
              <h3>Order Details</h3>
              <div class="select-past-order">
                <a href="javascript:void(0)"
                  [ngClass]="{'disabled': selectedSort == null? true: false, 'reset-btn':true}"
                  (click)="resetSort()">Reset</a>
                <p>Sort By:</p>
                <ng-select [items]="filters" [searchable]="false" bindLabel="name" [virtualScroll]="true" bindValue="id"
                  [(ngModel)]="selectedSort" (change)="productSort()" placeholder="Select">
                </ng-select>


              </div>
            </div>

            <div class="accordion-open-default ">
              <accordion [isAnimated]="true" [closeOthers]="true">
                <accordion-group [isOpen]="isFirstOpen1" *ngFor="let product of products">
                  <div class="accordion-heading align-items-start" accordion-heading>
                    <div class="status  d-block d-md-none {{orderStatueClasses[orderDetails['status']]}}">
                      <p>{{orderDetails['status']}}</p>
                    </div>
                    <div class="product-image">
                      <a href='javascript:void(0);'>
                        <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                      </a>
                    </div>

                    <ul class="items-and-cases">
                      <li>
                        <span>{{product.short_desc}} ({{product.unit_size}})
                        </span>
                        <p>{{product.barcode}} | {{product.sku}}</p>
                      </li>

                    </ul>
                  </div>
                  <ul class="table-list-items">
                    <li>
                      <span>RSP</span>
                      <p> <span class="price text-dark" *ngIf="product.rsp !== '0.00'">£{{product.rsp}}</span>
                        <span class="text-dark" *ngIf="product.rsp == '0.00'">N/A</span>
                        <span
                          *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && (product.sale_unit == 'Kilo' || product.sale_unit == 'Each'))">per
                          100g</span>
                        <span
                          *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && product.sale_unit.indexOf('C') !== -1)">each</span>
                      </p>
                    </li>
                    <li *ngIf="global_data?.margin_visibility == 1">
                      <span>Margin</span>
                      <p><span class="margin text-dark"> {{product.margin}}%</span></p>
                    </li>
                    <li *ngIf="global_data?.price_visibility == 1">
                      <span>Cost</span>
                      <p>£{{product.price}}</p>
                    </li>
                    <li>
                      <span>Order Qty</span>
                      <p>{{product.qty}}</p>
                    </li>
                    <li>
                      <span>Del Qty</span>
                      <p>{{product.qty_shipped}}</p>
                    </li>
                    <!-- <li class="status-li">
                      <div class="status {{orderStatueClasses[product.order_status]}}">
                        <p>{{product.order_status}}</p>
                      </div>
                    </li> -->
                  </ul>
                </accordion-group>

              </accordion>

            </div>

          </div>
        </div>
      </div>
      <div class="col-12 fixed-width-left-column">

        <div class="sticky-at-top">
          <div class="d-none d-lg-block">

            <div class="quick-add-box order-details">
              <h3 class="d-none d-lg-block">Order Details</h3>
              <div class="product-detail pb-0">
                <div class="status {{orderStatueClasses[orderDetails['status']]}}">
                  <p>{{orderDetails['status']}}</p>
                </div>
                <ul>
                  <li>
                    <p>Order Date</p>
                    <span>{{orderDetails['created_at'] | dateTimeFormatFilter: "d MMM, y"}}</span>
                  </li>
                  <li>
                    <p>Order ID</p>
                    <span>{{orderDetails['increment_id']}}</span>
                  </li>
                  <!-- <li>
                    <p>Order Source</p>
                    <span>WOS Website</span>
                  </li> -->
                  <li>
                    <p>Items</p>
                    <span>
                      {{orderDetails['total_items_delivered']}}/{{orderDetails['total_items']}} Delivered
                    </span>
                  </li>

                  <li>
                    <p>Cases</p>
                    <span>{{orderDetails['total_cases_delivered']}}/{{orderDetails['total_qty']}} Delivered</span>
                  </li>
                  <li>
                    <p>Store Name</p>
                    <span>{{orderDetails['store_name']}}</span>
                  </li>
                  <li>
                    <p>PO Number</p>
                    <span>{{orderDetails['po_number']}}</span>
                  </li>
                </ul>


              </div>
              <div class="product-detail cart-product-detail">

                <div class="promotion-listing discount first" *ngIf="global_data['price_visibility'] == 1">
                  <h5>
                    Net Amount:
                  </h5>
                  <span *ngIf="orderDetails['cart_total'] != undefined">£{{orderDetails['cart_total']?.subtotal}}</span>
                </div>
                <div class="promotion-listing"
                  *ngIf='orderDetails["cart_total"]?.promotions != undefined && orderDetails["cart_total"]?.promotions?.length != 0 && global_data["price_visibility"] == 1'>
                  <h5>
                    Promotion:
                  </h5>
                  <ul>
                    <li *ngFor="let pro of orderDetails['cart_total']?.promotions">
                      <p>{{pro.name}}</p><span class="red" *ngIf=" global_data?.price_visibility == 1">-
                        £{{pro.discount}}</span>
                    </li>
                  </ul>
                </div>
                <div class="promotion-listing discount"
                  *ngIf=" orderDetails.cart_total != undefined &&  global_data?.price_visibility == 1 && (orderDetails['cart_total']?.store_discount != '' && orderDetails['cart_total']?.store_discount > 0)">

                  <h5>
                    Discount Applied:
                  </h5>
                  <span class="red">- £{{orderDetails['cart_total']?.store_discount}}</span>
                </div>
                <div class="promotion-listing discount" *ngIf=" global_data?.price_visibility == 1 && (orderDetails['cart_total'] != undefined) &&  convertToInt(orderDetails['cart_total']?.vat) > 0">
                  <h5>
                    VAT:
                  </h5>
                  <span *ngIf="orderDetails['cart_total'] != undefined ">£{{orderDetails['cart_total']?.vat}}</span>
                </div>
                <div class="promotion-listing discount total" *ngIf=" global_data?.price_visibility == 1">
                  <h5>
                    Total Amount:
                  </h5>
                  <span
                    *ngIf="orderDetails['cart_total'] != undefined">£{{orderDetails['cart_total']?.grand_total}}</span>
                </div>

                <button *ngIf="orderDetails.copy_invoice_pdf_name !== null"
                  class="view-btn btn primary-btn w-100 rounded-pill"
                  (click)='clickEvent(orderDetails.copy_invoice_pdf_name)'> View Invoice </button>
              </div>
            </div>
            <div class="invoice-discount"
              *ngIf="orderDetails['discount_description'] != null && global_data['price_visibility'] != 1 ">
              <img src="../../assets/images/percent-icon.svg" alt="percent-icon"> Invoice discount will be applied to
              these values.
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
  <div class="row no-result" *ngIf="!componentLoaded">
    <div class="col-12">
      <div class="no-result-content text-center">
        <img src="../../assets/images/hourglass-shb.svg" alt="no-result">
        <p>Loading...</p>
      </div>
    </div>
  </div>
</div>